import React from "react";
import { MedsOnlyTreatmentsScreen } from "./MedsOnlyTreatmentsScreen";

export function OITreatmentsScreen() {
  return <MedsOnlyTreatmentsScreen mode="oi" />;
}

export default OITreatmentsScreen;
